import { render, staticRenderFns } from "./inviteOpenQuestion.vue?vue&type=template&id=638ace66&scoped=true"
import script from "./inviteOpenQuestion.vue?vue&type=script&lang=js"
export * from "./inviteOpenQuestion.vue?vue&type=script&lang=js"
import style0 from "./inviteOpenQuestion.vue?vue&type=style&index=0&id=638ace66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ace66",
  null
  
)

export default component.exports